<template>
  <Modal>
    <Modal.Title>Change bio</Modal.Title>
    <Modal.Body>
      <Textarea v-model="bio" label="Bio" :disabled="loading" />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="!canSave"
        :loading="loading"
        @click="handleSave"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Textarea, Button, useModal } from '@dacr/library'
import type { User } from '@/shared/graphql/legacy/generated'
import { useChangeBio } from './useChangeBio'

const { close } = useModal()

const props = defineProps<{
  user: User
}>()

const { bio, loading, canSave, save } = useChangeBio(props.user)

const handleSave = async () => {
  if (await save()) close()
}
</script>
